import { BDESE_TEMPLATE_CONFIG } from './bdese'
import { EGAPRO_INDEX_TEMPLATE_CONFIG } from './egaproIndex'
import { CUSTOM_REPORT_TEMPLATE_CONFIG } from './customReport'
import { FilterOperator } from '~/types/cube'
import {
  LegalReportType,
  LegalReportTemplate,
  type LegalReportConfig,
  type TemplateConfig
} from '~/types/legalReports/main'
import type { TranslationKeys } from '~/plugins/i18n'
import { RefreshDataActionType } from '~/types/legalReports/sectionContent'

export const LEGAL_REPORTS_CONFIG_BY_TYPE: {
  [key in LegalReportType]: LegalReportConfig
} = {
  [LegalReportType.BDESE]: {
    name: 'bdese',
    isCreationEnabled: true,
    emoji: '💽',
    title: 'legalReports.bdese.title',
    description: 'legalReports.bdese.description',
    typeTitle: 'legalReports.bdese.typeTitle'
  },
  [LegalReportType.EGAPRO_INDEX]: {
    name: 'egaproIndex',
    isCreationEnabled: true,
    emoji: '⚖️',
    title: 'legalReports.egaproIndex.title',
    description: 'legalReports.egaproIndex.description',
    typeTitle: 'legalReports.egaproIndex.typeTitle'
  },
  [LegalReportType.CUSTOM_REPORT]: {
    name: 'customReport',
    isCreationEnabled: true,
    emoji: '🎨',
    title: 'legalReports.customReport.title',
    description: 'legalReports.customReport.description',
    typeTitle: 'legalReports.customReport.typeTitle'
  }
}

export const LEGAL_REPORT_TEMPLATE_CONFIG: {
  [key in LegalReportTemplate]: TemplateConfig
} = {
  ...BDESE_TEMPLATE_CONFIG,
  ...EGAPRO_INDEX_TEMPLATE_CONFIG,
  ...CUSTOM_REPORT_TEMPLATE_CONFIG
}

export const ALLOWED_LEGAL_REPORT_SCOPE_FILTER_OPERATORS = [
  FilterOperator.EQUALS,
  FilterOperator.NOT_EQUALS,
  FilterOperator.CONTAINS,
  FilterOperator.NOT_CONTAINS
]

export const LEGAL_REPORT_SCOPE_FILTER_MAX_COUNT = 2

export const MAX_LEGAL_REPORT_TITLE_LENGTH = 32
export const MAX_LEGAL_REPORT_DESCRIPTION_LENGTH = 300

export const LEGAL_REPORT_REALIZED_YEAR_OPTIONS = [1, 2, 3]
export const LEGAL_REPORT_TREND_YEAR_OPTIONS = [0, 1, 2, 3]

export const REFRESH_MODAL_CONTENT_BY_ACTION_TYPE: {
  [key in RefreshDataActionType]: {
    title: TranslationKeys
    description: TranslationKeys
  }
} = {
  [RefreshDataActionType.ALL_DATA]: {
    title: 'legalReports.editorPanel.refresh.allData.title',
    description: 'legalReports.editorPanel.refresh.allData.description'
  },
  [RefreshDataActionType.TABLE]: {
    title: 'legalReports.editorPanel.refresh.table.title',
    description: 'legalReports.editorPanel.refresh.table.description'
  },
  [RefreshDataActionType.CHART]: {
    title: 'legalReports.editorPanel.refresh.chart.title',
    description: 'legalReports.editorPanel.refresh.chart.description'
  }
}
